import { render, staticRenderFns } from "./SquareTemplate.vue?vue&type=template&id=1c49b4ca&scoped=true&"
import script from "./SquareTemplate.vue?vue&type=script&lang=js&"
export * from "./SquareTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49b4ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c49b4ca')) {
      api.createRecord('1c49b4ca', component.options)
    } else {
      api.reload('1c49b4ca', component.options)
    }
    module.hot.accept("./SquareTemplate.vue?vue&type=template&id=1c49b4ca&scoped=true&", function () {
      api.rerender('1c49b4ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/SquareTemplate.vue"
export default component.exports